import { Badge, BadgeColor } from '@givebutter/primitives/badge';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBan, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentTransactionOrById } from 'customHooks/useCurrentTransactionOrById';
import { DateTime } from 'luxon';
import { Ticket } from 'types/domain';

interface TicketStatusBadgeProps {
    ticket: Ticket;
}

const TicketStatusBadge = (props: TicketStatusBadgeProps) => {
    const { timezone } = useCurrentAccount();
    const { ticket } = props;

    const { data: transaction } = useCurrentTransactionOrById({
        transactionId: ticket.transaction_id,
    });

    const finalTimezone = transaction?.campaign?.timezone || timezone || 'utc';
    const { message, color, icon } = getTicketStatusProps(ticket, finalTimezone);

    return (
        <Badge size="sm" color={color}>
            {icon && <FontAwesomeIcon size={'sm'} icon={icon} />}
            {message}
        </Badge>
    );
};

const getTicketStatusProps = (ticket: Ticket, tz: string) => {
    let message = 'Not present';
    let color: BadgeColor = 'neutral';
    let icon: IconDefinition | undefined;

    if (ticket.revoked_at) {
        message = 'Revoked';
        color = 'error';
        icon = faBan;
    } else if (ticket.checked_in_at) {
        const formattedDate = DateTime.fromISO(ticket.checked_in_at)
            .setZone(tz)
            .toFormat('MMMM d, yyyy h:mm a');

        message = `Checked in ${formattedDate}`;
        color = 'success';
        icon = faCheck;
    }

    return {
        message,
        color,
        icon,
    };
};

export { TicketStatusBadge };
